import { URL, handleErrors } from "./depannageActions"
import { fetchInventaireLimitChecker } from "./atelierInventaireActions"
import { catchApiError } from "./apiHelpers"

export const FETCH_ATELIER_FILES_SUCCESS = "FETCH_ATELIER_FILES_SUCCESS"
export const fetchAtelierFiles = (id) => {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		let url = `${URL}api/atelier_files?id=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) =>
				dispatch({ type: FETCH_ATELIER_FILES_SUCCESS, payload: json }),
			)
	}
}

export const FETCH_ATELIER_TRANSACTIONS_BEGIN =
	"FETCH_ATELIER_TRANSACTIONS_BEGIN"
export const FETCH_ATELIER_TRANSACTIONS_ERROR =
	"FETCH_ATELIER_TRANSACTIONS_ERROR"
export const FETCH_ATELIER_TRANSACTIONS_SUCCESS =
	"FETCH_ATELIER_TRANSACTIONS_SUCCESS"

export const fetchAtelierTransactionsBegin = () => ({
	type: FETCH_ATELIER_TRANSACTIONS_BEGIN,
})

export const fetchAtelierTransactionsError = (payload) => ({
	type: FETCH_ATELIER_TRANSACTIONS_ERROR,
	payload,
})

export const fetchAtelierTransactionsSuccess = (payload) => ({
	type: FETCH_ATELIER_TRANSACTIONS_SUCCESS,
	payload,
})

export function fetchAtelierTransactions(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchAtelierTransactionsBegin())
		let url = `${URL}api/atelier_transaction?atelier_id=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchAtelierTransactionsSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchAtelierTransactionsError))
	}
}

export const POST_ATELIER_TRANSACTION_BEGIN = "POST_ATELIER_TRANSACTION_BEGIN"
export const POST_ATELIER_TRANSACTION_ERROR = "POST_ATELIER_TRANSACTION_ERROR"
export const POST_ATELIER_TRANSACTION_SUCCESS =
	"POST_ATELIER_TRANSACTION_SUCCESS"
export const POST_ATELIER_TRANSACTION_RESET = "POST_ATELIER_TRANSACTION_RESET"

export const postAtelierTransactionBegin = () => ({
	type: POST_ATELIER_TRANSACTION_BEGIN,
})

export const postAtelierTransactionReset = () => ({
	type: POST_ATELIER_TRANSACTION_RESET,
})

export const postAtelierTransactionError = (payload) => ({
	type: POST_ATELIER_TRANSACTION_ERROR,
	payload,
})

export const postAtelierTransactionSuccess = (payload) => ({
	type: POST_ATELIER_TRANSACTION_SUCCESS,
	payload,
})

export function postAtelierTransaction(formData) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postAtelierTransactionBegin())
		return fetch(`${URL}api/atelier_transaction`, {
			method: "post",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: formData,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postAtelierTransactionSuccess(json))
			})
			.catch(catchApiError(dispatch, postAtelierTransactionError))
	}
}

export const POST_ATELIER_TRANSACTION_FILE_BEGIN =
	"POST_ATELIER_TRANSACTION_FILE_BEGIN"
export const POST_ATELIER_TRANSACTION_FILE_ERROR =
	"POST_ATELIER_TRANSACTION_FILE_ERROR"
export const POST_ATELIER_TRANSACTION_FILE_SUCCESS =
	"POST_ATELIER_TRANSACTION_FILE_SUCCESS"
export const POST_ATELIER_TRANSACTION_FILE_RESET =
	"POST_ATELIER_TRANSACTION_FILE_RESET"

export const postAtelierTransactionFileBegin = () => ({
	type: POST_ATELIER_TRANSACTION_FILE_BEGIN,
})

export const postAtelierTransactionFileReset = () => ({
	type: POST_ATELIER_TRANSACTION_FILE_RESET,
})

export const postAtelierTransactionFileError = (payload) => ({
	type: POST_ATELIER_TRANSACTION_FILE_ERROR,
	payload,
})

export const postAtelierTransactionFileSuccess = (payload) => ({
	type: POST_ATELIER_TRANSACTION_FILE_SUCCESS,
	payload,
})

export function postAtelierTransactionFile(formData) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postAtelierTransactionFileBegin())
		return fetch(`${URL}api/atelier_transaction`, {
			method: "post",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: formData,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postAtelierTransactionFileSuccess(json))
			})
			.catch(catchApiError(dispatch, postAtelierTransactionFileError))
	}
}

export const DELETE_ATELIER_TRANSACTION_FILE_BEGIN =
	"DELETE_ATELIER_TRANSACTION_FILE_BEGIN"
export const DELETE_ATELIER_TRANSACTION_FILE_ERROR =
	"DELETE_ATELIER_TRANSACTION_FILE_ERROR"
export const DELETE_ATELIER_TRANSACTION_FILE_SUCCESS =
	"DELETE_ATELIER_TRANSACTION_FILE_SUCCESS"
export const DELETE_ATELIER_TRANSACTION_FILE_RESET =
	"DELETE_ATELIER_TRANSACTION_FILE_RESET"

export const deleteAtelierTransactionFileBegin = () => ({
	type: DELETE_ATELIER_TRANSACTION_FILE_BEGIN,
})

export const deleteAtelierTransactionFileReset = () => ({
	type: DELETE_ATELIER_TRANSACTION_FILE_RESET,
})

export const deleteAtelierTransactionFileError = (payload) => ({
	type: DELETE_ATELIER_TRANSACTION_FILE_ERROR,
	payload,
})

export const deleteAtelierTransactionFileSuccess = (payload) => ({
	type: DELETE_ATELIER_TRANSACTION_FILE_SUCCESS,
	payload,
})

export function deleteAtelierTransactionFile(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteAtelierTransactionFileBegin())
		return fetch(`${URL}api/atelier_transaction`, {
			method: "delete",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteAtelierTransactionFileSuccess(json))
			})
			.catch(catchApiError(dispatch, deleteAtelierTransactionFileError))
	}
}

export const ATELIER_DELETE_DOC_RESTITUTION_BEGIN =
	"ATELIER_DELETE_DOC_RESTITUTION_BEGIN"
export const ATELIER_DELETE_DOC_RESTITUTION_ERROR =
	"ATELIER_DELETE_DOC_RESTITUTION_ERROR"
export const ATELIER_DELETE_DOC_RESTITUTION_RESET =
	"ATELIER_DELETE_DOC_RESTITUTION_RESET"
export const ATELIER_DELETE_DOC_RESTITUTION_DONE =
	"ATELIER_DELETE_DOC_RESTITUTION_DONE"

export const atelierDeleteDocRestitutionDone = () => ({
	type: ATELIER_DELETE_DOC_RESTITUTION_DONE,
})

export const atelierDeleteDocRestitutionBegin = () => ({
	type: ATELIER_DELETE_DOC_RESTITUTION_BEGIN,
})

export const atelierDeleteDocRestitutionReset = () => ({
	type: ATELIER_DELETE_DOC_RESTITUTION_RESET,
})

export function atelierDeleteDocRestitution(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(atelierDeleteDocRestitutionBegin())
		return fetch(`${URL}api/atelier_doc_signe`, {
			method: "post",
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ id: id }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then(() => {
				dispatch(atelierDeleteDocRestitutionDone())
			})
	}
}

export const POST_ATELIER_FILES_BEGIN = "POST_ATELIER_FILES_BEGIN"
export const POST_ATELIER_FILES_ERROR = "POST_ATELIER_FILES_ERROR"
export const POST_ATELIER_FILES_SUCCESS = "POST_ATELIER_FILES_SUCCESS"
export const POST_ATELIER_FILES_RESET = "POST_ATELIER_FILES_RESET"

export const postAtelierFilesBegin = () => ({
	type: POST_ATELIER_FILES_BEGIN,
})

export const postAtelierFilesReset = () => ({
	type: POST_ATELIER_FILES_RESET,
})

export const postAtelierFilesError = (payload) => ({
	type: POST_ATELIER_FILES_ERROR,
	payload,
})

export const postAtelierFilesSuccess = (payload) => ({
	type: POST_ATELIER_FILES_SUCCESS,
	payload,
})

export function postAtelierFiles(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postAtelierFilesBegin())
		return fetch(`${URL}api/atelier_files`, {
			method: "post",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postAtelierFilesSuccess(json))
			})
			.catch(catchApiError(dispatch, postAtelierFilesError))
	}
}

export const POST_ATELIER_DOC_RESTITUTION_BEGIN =
	"POST_ATELIER_DOC_RESTITUTION_BEGIN"
export const POST_ATELIER_DOC_RESTITUTION_ERROR =
	"POST_ATELIER_DOC_RESTITUTION_ERROR"
export const POST_ATELIER_DOC_RESTITUTION_SUCCESS =
	"POST_ATELIER_DOC_RESTITUTION_SUCCESS"
export const POST_ATELIER_DOC_RESTITUTION_RESET =
	"POST_ATELIER_DOC_RESTITUTION_RESET"

export const postAtelierDocRestitutionBegin = () => ({
	type: POST_ATELIER_DOC_RESTITUTION_BEGIN,
})

export const postAtelierDocRestitutionReset = () => ({
	type: POST_ATELIER_DOC_RESTITUTION_RESET,
})

export const postAtelierDocRestitutionError = (payload) => ({
	type: POST_ATELIER_DOC_RESTITUTION_ERROR,
	payload,
})

export const postAtelierDocRestitutionSuccess = (payload) => ({
	type: POST_ATELIER_DOC_RESTITUTION_SUCCESS,
	payload,
})

export function postAtelierDocRestitution(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postAtelierDocRestitutionBegin())
		return fetch(`${URL}api/atelier_doc_restitution`, {
			method: "post",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postAtelierDocRestitutionSuccess(json))
			})
			.catch(catchApiError(dispatch, postAtelierDocRestitutionError))
	}
}

export const DELETE_ATELIER_FILE_BEGIN = "DELETE_ATELIER_FILE_BEGIN"
export const DELETE_ATELIER_FILE_ERROR = "DELETE_ATELIER_FILE_ERROR"
export const DELETE_ATELIER_FILE_SUCCESS = "DELETE_ATELIER_FILE_SUCCESS"
export const DELETE_ATELIER_FILE_RESET = "DELETE_ATELIER_FILE_RESET"

export const deleteAtelierFileBegin = () => ({
	type: DELETE_ATELIER_FILE_BEGIN,
})

export const deleteAtelierFileReset = () => ({
	type: DELETE_ATELIER_FILE_RESET,
})

export const deleteAtelierFileError = (payload) => ({
	type: DELETE_ATELIER_FILE_ERROR,
	payload,
})

export const deleteAtelierFileSuccess = (payload) => ({
	type: DELETE_ATELIER_FILE_SUCCESS,
	payload,
})

export function deleteAtelierFile(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteAtelierFileBegin())
		return fetch(`${URL}api/atelier_files`, {
			method: "delete",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteAtelierFileSuccess(json))
			})
			.catch(catchApiError(dispatch, deleteAtelierFileError))
	}
}

// Les e-mails ont leur propre slice depuis GE-25 (store/actions/emailActions.js) :
// la file est générique atelier/dépannage, elle n'a plus sa place ici.

export const FETCH_ATELIER_ENTITE_BEGIN = "FETCH_ATELIER_ENTITE_BEGIN"
export const FETCH_ATELIER_ENTITE_ERROR = "FETCH_ATELIER_ENTITE_ERROR"
export const FETCH_ATELIER_ENTITE_SUCCESS = "FETCH_ATELIER_ENTITE_SUCCESS"

export const fetchAtelierEntiteBegin = () => ({
	type: FETCH_ATELIER_ENTITE_BEGIN,
})

export const fetchAtelierEntiteError = (payload) => ({
	type: FETCH_ATELIER_ENTITE_ERROR,
	payload,
})

export const fetchAtelierEntiteSuccess = (payload) => ({
	type: FETCH_ATELIER_ENTITE_SUCCESS,
	payload,
})

export function fetchAtelierEntite(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchAtelierEntiteBegin())
		let url = `${URL}api/entites?id=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchAtelierEntiteSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, fetchAtelierEntiteError))
	}
}

export const FETCH_LOADATELIERMODELE_BEGIN = "FETCH_LOADATELIERMODELE_BEGIN"
export const FETCH_LOADATELIERMODELE_ERROR = "FETCH_LOADATELIERMODELE_ERROR"
export const FETCH_LOADATELIERMODELE_SUCCESS = "FETCH_LOADATELIERMODELE_SUCCESS"

export const fetchLoadAtelierModeleBegin = () => ({
	type: FETCH_LOADATELIERMODELE_BEGIN,
})

export const fetchLoadAtelierModeleError = (error) => ({
	type: FETCH_LOADATELIERMODELE_ERROR,
	payload: { error },
})

export const fetchLoadAtelierModeleSuccess = (data) => ({
	type: FETCH_LOADATELIERMODELE_SUCCESS,
	payload: { data },
})

export function fetchLoadAtelierModele(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchLoadAtelierModeleBegin())
		let url = `${URL}api/atelierloadmodeles?id=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchLoadAtelierModeleSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchLoadAtelierModeleError))
	}
}

//////////////////////////////////////////////////////////////
//                          CLIENT                          //
//////////////////////////////////////////////////////////////

export const FETCH_CLIENT_BEGIN = "FETCH_CLIENT_BEGIN"
export const FETCH_CLIENT_ERROR = "FETCH_CLIENT_ERROR"
export const FETCH_CLIENT_SUCCESS = "FETCH_CLIENT_SUCCESS"

export const fetchClientBegin = () => ({
	type: FETCH_CLIENT_BEGIN,
})

export const fetchClientError = (error) => ({
	type: FETCH_CLIENT_ERROR,
	payload: { error },
})

export const fetchClientSuccess = (client) => ({
	type: FETCH_CLIENT_SUCCESS,
	payload: { client },
})

export function fetchClient(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchClientBegin())
		let url = `${URL}api/clients?id=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(fetchClientSuccess(json)))
			.catch(catchApiError(dispatch, fetchClientError))
	}
}

//////////////////////////////////////////////////////////////
//                CLIENT FROM VEHICULE ID                   //
//////////////////////////////////////////////////////////////

export const FETCH_CLIENTS_FROM_VEHICULE_BEGIN =
	"FETCH_CLIENTS_FROM_VEHICULE_BEGIN"
export const FETCH_CLIENTS_FROM_VEHICULE_ERROR =
	"FETCH_CLIENTS_FROM_VEHICULE_ERROR"
export const FETCH_CLIENTS_FROM_VEHICULE_SUCCESS =
	"FETCH_CLIENTS_FROM_VEHICULE_SUCCESS"

export const fetchClientsFromVehiculeBegin = () => ({
	type: FETCH_CLIENTS_FROM_VEHICULE_BEGIN,
})

export const fetchClientsFromVehiculeError = (error) => ({
	type: FETCH_CLIENTS_FROM_VEHICULE_ERROR,
	payload: { error },
})

export const fetchClientsFromVehiculeSuccess = (clientsFromVehicule) => ({
	type: FETCH_CLIENTS_FROM_VEHICULE_SUCCESS,
	payload: { clientsFromVehicule },
})

export function fetchClientsFromVehicule(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchClientsFromVehiculeBegin())
		let url = `${URL}api/clients?vehiculeId=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(fetchClientsFromVehiculeSuccess(json)))
			.catch(catchApiError(dispatch, fetchClientsFromVehiculeError))
	}
}

//////////////////////////////////////////////////////////////
//                      CLIENT LIST                         //
//////////////////////////////////////////////////////////////

export const FETCH_CLIENTLIST_BEGIN = "FETCH_CLIENTLIST_BEGIN"
export const FETCH_CLIENTLIST_ERROR = "FETCH_CLIENTLIST_ERROR"
export const FETCH_CLIENTLIST_SUCCESS = "FETCH_CLIENTLIST_SUCCESS"

export const fetchClientListBegin = () => ({
	type: FETCH_CLIENTLIST_BEGIN,
})

export const fetchClientListError = (error) => ({
	type: FETCH_CLIENTLIST_ERROR,
	payload: { error },
})

export const fetchClientListSuccess = (clientList) => ({
	type: FETCH_CLIENTLIST_SUCCESS,
	payload: { clientList },
})

export function fetchClientList() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchClientListBegin())
		let url = `${URL}api/clients`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchClientListSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchClientListError))
	}
}

//////////////////////////////////////////////////////////////
//                      VEHICULE LIST                         //
//////////////////////////////////////////////////////////////

export const FETCH_VEHICULELIST_BEGIN = "FETCH_VEHICULELIST_BEGIN"
export const FETCH_VEHICULELIST_ERROR = "FETCH_VEHICULELIST_ERROR"
export const FETCH_VEHICULELIST_SUCCESS = "FETCH_VEHICULELIST_SUCCESS"

export const fetchVehiculeListBegin = () => ({
	type: FETCH_VEHICULELIST_BEGIN,
})

export const fetchVehiculeListError = (error) => ({
	type: FETCH_VEHICULELIST_ERROR,
	payload: { error },
})

export const fetchVehiculeListSuccess = (vehiculeList) => ({
	type: FETCH_VEHICULELIST_SUCCESS,
	payload: { vehiculeList },
})

export function fetchVehiculeList() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchVehiculeListBegin())
		let url = `${URL}api/clientvehicules`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchVehiculeListSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchVehiculeListError))
	}
}

export const POST_CLIENT_BEGIN = "POST_CLIENT_BEGIN"
export const POST_CLIENT_ERROR = "POST_CLIENT_ERROR"
export const POST_CLIENT_SUCCESS = "POST_CLIENT_SUCCESS"
export const POST_CLIENT_RESET = "POST_CLIENT_RESET"

export const postClientBegin = () => ({
	type: POST_CLIENT_BEGIN,
})

export const postClientReset = () => ({
	type: POST_CLIENT_RESET,
})

export const postClientError = (error) => ({
	type: POST_CLIENT_ERROR,
	payload: { error },
})

export const postClientSuccess = (client) => ({
	type: POST_CLIENT_SUCCESS,
	payload: { client },
})

export function postClient(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postClientBegin())
		return fetch(`${URL}api/clients`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postClientSuccess(json))
			})
			.catch(catchApiError(dispatch, postClientError))
	}
}

//////////////////////////////////////////////////////////////
//                      CLIENT VEHICULES                    //
//////////////////////////////////////////////////////////////

export const FETCH_CLIENTVEHICULES_BEGIN = "FETCH_CLIENTVEHICULES_BEGIN"
export const FETCH_CLIENTVEHICULES_ERROR = "FETCH_CLIENTVEHICULES_ERROR"
export const FETCH_CLIENTVEHICULES_SUCCESS = "FETCH_CLIENTVEHICULES_SUCCESS"

export const fetchClientVehiculesBegin = () => ({
	type: FETCH_CLIENTVEHICULES_BEGIN,
})

export const fetchClientVehiculesError = (error) => ({
	type: FETCH_CLIENTVEHICULES_ERROR,
	payload: { error },
})

export const fetchClientVehiculesSuccess = (clientVehicules) => ({
	type: FETCH_CLIENTVEHICULES_SUCCESS,
	payload: { clientVehicules },
})

export function fetchClientVehicules(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchClientVehiculesBegin())
		let url = `${URL}api/clientvehicules?`
		for (let key in kwargs) {
			url += `${key}=${kwargs[key]}&`
		}
		url = url.substring(0, url.length - 1)
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchClientVehiculesSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchClientVehiculesError))
	}
}

export const POST_CLIENTVEHICULES_BEGIN = "POST_CLIENTVEHICULES_BEGIN"
export const POST_CLIENTVEHICULES_ERROR = "POST_CLIENTVEHICULES_ERROR"
export const POST_CLIENTVEHICULES_SUCCESS = "POST_CLIENTVEHICULES_SUCCESS"
export const POST_CLIENTVEHICULES_RESET = "POST_CLIENTVEHICULES_RESET"

export const postClientVehiculesBegin = () => ({
	type: POST_CLIENTVEHICULES_BEGIN,
})

export const postClientVehiculesReset = () => ({
	type: POST_CLIENTVEHICULES_RESET,
})

export const postClientVehiculesError = (error) => ({
	type: POST_CLIENTVEHICULES_ERROR,
	payload: { error },
})

export const postClientVehiculesSuccess = (clientVehicules) => ({
	type: POST_CLIENTVEHICULES_SUCCESS,
	payload: { clientVehicules },
})

export function postClientVehicules(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postClientVehiculesBegin())
		return fetch(`${URL}api/clientvehicules`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postClientVehiculesSuccess(json))
			})
			.catch(catchApiError(dispatch, postClientVehiculesError))
	}
}

//////////////////////////////////////////////////////////////
//                          ATELIER                         //
//////////////////////////////////////////////////////////////

export const FETCH_ATELIER_BEGIN = "FETCH_ATELIER_BEGIN"
export const FETCH_ATELIER_ERROR = "FETCH_ATELIER_ERROR"
export const FETCH_ATELIER_SUCCESS = "FETCH_ATELIER_SUCCESS"
export const FETCH_ATELIER_RESET = "FETCH_ATELIER_RESET"

export const fetchAtelierBegin = () => ({
	type: FETCH_ATELIER_BEGIN,
})

export const fetchAtelierError = (error) => ({
	type: FETCH_ATELIER_ERROR,
	payload: { error },
})

export const fetchAtelierSuccess = (payload) => ({
	type: FETCH_ATELIER_SUCCESS,
	payload,
})

export const fetchAtelierReset = () => {
	return (dispatch) => {
		dispatch({
			type: FETCH_ATELIER_RESET,
		})
		return Promise.resolve()
	}
}

export function fetchAtelier(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchAtelierBegin())
		let url = `${URL}api/ateliers?id=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(fetchAtelierSuccess(json)))
			.catch(catchApiError(dispatch, fetchAtelierError))

		// try {
		//     const response = await fetch(url, { headers: { Authorization: `Bearer ${token}` } })
		//     const res = await handleErrors(response)
		//     const json = res.json()
		//     dispatch(fetchAtelierSuccess(json))
		// } catch (error) {
		// }
	}
}

export const FETCH_ATELIERSTATE_BEGIN = "FETCH_ATELIERSTATE_BEGIN"
export const FETCH_ATELIERSTATE_ERROR = "FETCH_ATELIERSTATE_ERROR"
export const FETCH_ATELIERSTATE_SUCCESS = "FETCH_ATELIERSTATE_SUCCESS"

export const fetchAtelierStateBegin = () => ({
	type: FETCH_ATELIERSTATE_BEGIN,
})

export const fetchAtelierStateError = (error) => ({
	type: FETCH_ATELIERSTATE_ERROR,
	payload: { error },
})

export const fetchAtelierStateSuccess = (atelierState, pagination) => ({
	type: FETCH_ATELIERSTATE_SUCCESS,
	payload: { atelierState, pagination },
})

export function fetchAtelierState(menu, page = 1) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchAtelierStateBegin())
		let url = `${URL}api/atelierstate?menu=${menu}&page=${page}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				// Réponse paginée { results, count, page, num_pages, page_size }.
				// Tolère l'ancien format tableau (legacy) par sécurité.
				const results = Array.isArray(json) ? json : json.results
				const pagination = Array.isArray(json)
					? null
					: {
							count: json.count,
							page: json.page,
							numPages: json.num_pages,
							pageSize: json.page_size,
						}
				dispatch(fetchAtelierStateSuccess(results, pagination))
			})
			.catch(catchApiError(dispatch, fetchAtelierStateError))
	}
}

export const POST_ATELIER_BEGIN = "POST_ATELIER_BEGIN"
export const POST_ATELIER_ERROR = "POST_ATELIER_ERROR"
export const POST_ATELIER_SUCCESS = "POST_ATELIER_SUCCESS"
export const POST_ATELIER_RESET = "POST_ATELIER_RESET"
export const POST_ATELIER_ERRORFIELD = "POST_ATELIER_ERRORFIELD"

export const postAtelierBegin = () => ({
	type: POST_ATELIER_BEGIN,
})

export const postAtelierReset = () => ({
	type: POST_ATELIER_RESET,
})

export const postAtelierError = (error) => ({
	type: POST_ATELIER_ERROR,
	payload: { error },
})

export const postAtelierSuccess = (payload) => ({
	type: POST_ATELIER_SUCCESS,
	payload,
})

export const postAtelierErrorField = (errorFields) => ({
	type: POST_ATELIER_ERRORFIELD,
	payload: { errorFields },
})

// silent=true par défaut : les flux modaux V2 (SaveAtelierV2, Facturation…)
// affichent l'erreur eux-mêmes. silent=false pour un save « nu » (bouton
// Sauvegarder simple) qui n'a pas de surface d'erreur → toast automatique.
export function postAtelier(data, del = -1, silent = true) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postAtelierBegin())
		let url = `${URL}api/ateliers`
		if (del !== -1) url = `${url}?delId=${del}`
		return fetch(url, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postAtelierSuccess(json))
				dispatch(fetchInventaireLimitChecker())
				return json
			})
			.catch(catchApiError(dispatch, postAtelierError, { silent }))
	}
}

//////////////////////////////////////////////////////////////
//                    ATELIER COMMENTAIRES                  //
//////////////////////////////////////////////////////////////

export const FETCH_ATELIERCOMMENTAIRES_BEGIN = "FETCH_ATELIERCOMMENTAIRES_BEGIN"
export const FETCH_ATELIERCOMMENTAIRES_ERROR = "FETCH_ATELIERCOMMENTAIRES_ERROR"
export const FETCH_ATELIERCOMMENTAIRES_SUCCESS =
	"FETCH_ATELIERCOMMENTAIRES_SUCCESS"

export const fetchAtelierCommentairesBegin = () => ({
	type: FETCH_ATELIERCOMMENTAIRES_BEGIN,
})

export const fetchAtelierCommentairesError = (error) => ({
	type: FETCH_ATELIERCOMMENTAIRES_ERROR,
	payload: { error },
})

export const fetchAtelierCommentairesSuccess = (atelierCommentaires) => ({
	type: FETCH_ATELIERCOMMENTAIRES_SUCCESS,
	payload: { atelierCommentaires },
})

export function fetchAtelierCommentaires(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchAtelierCommentairesBegin())
		let url = `${URL}api/ateliercommentaires?id=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchAtelierCommentairesSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchAtelierCommentairesError))
	}
}

//////////////////////////////////////////////////////////////
//                    ATELIER LIGNE                         //
//////////////////////////////////////////////////////////////

export const FETCH_ATELIERLIGNES_BEGIN = "FETCH_ATELIERLIGNES_BEGIN"
export const FETCH_ATELIERLIGNES_ERROR = "FETCH_ATELIERLIGNES_ERROR"
export const FETCH_ATELIERLIGNES_SUCCESS = "FETCH_ATELIERLIGNES_SUCCESS"

export const fetchAtelierLignesBegin = () => ({
	type: FETCH_ATELIERLIGNES_BEGIN,
})

export const fetchAtelierLignesError = (error) => ({
	type: FETCH_ATELIERLIGNES_ERROR,
	payload: { error },
})

export const fetchAtelierLignesSuccess = (atelierLignes) => ({
	type: FETCH_ATELIERLIGNES_SUCCESS,
	payload: { atelierLignes },
})

export function fetchAtelierLignes(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchAtelierLignesBegin())
		let url = `${URL}api/atelierlignes?id=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchAtelierLignesSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchAtelierLignesError))
	}
}

export const POST_ATELIERLIGNES_BEGIN = "POST_ATELIERLIGNES_BEGIN"
export const POST_ATELIERLIGNES_ERROR = "POST_ATELIERLIGNES_ERROR"
export const POST_ATELIERLIGNES_SUCCESS = "POST_ATELIERLIGNES_SUCCESS"
export const POST_ATELIERLIGNES_RESET = "POST_ATELIERLIGNES_RESET"

export const postAtelierLignesBegin = () => ({
	type: POST_ATELIERLIGNES_BEGIN,
})

export const postAtelierLignesReset = () => ({
	type: POST_ATELIERLIGNES_RESET,
})

export const postAtelierLignesError = (error) => ({
	type: POST_ATELIERLIGNES_ERROR,
	payload: { error },
})

export const postAtelierLignesSuccess = (atelierLignes) => ({
	type: POST_ATELIERLIGNES_SUCCESS,
	payload: { atelierLignes },
})

export function postAtelierLignes(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postAtelierLignesBegin())
		return fetch(`${URL}api/atelierlignes`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postAtelierLignesSuccess(json))
			})
			.catch(catchApiError(dispatch, postAtelierLignesError))
	}
}

export const FETCH_AL_PA_BEGIN = "FETCH_AL_PA_BEGIN"
export const FETCH_AL_PA_ERROR = "FETCH_AL_PA_ERROR"
export const FETCH_AL_PA_SUCCESS = "FETCH_AL_PA_SUCCESS"
export const FETCH_AL_PA_RESET = "FETCH_AL_PA_RESET"

export const fetchALPABegin = () => ({
	type: FETCH_AL_PA_BEGIN,
})

export const fetchALPAReset = () => ({
	type: FETCH_AL_PA_RESET,
})

export const fetchALPAError = (error) => ({
	type: FETCH_AL_PA_ERROR,
	payload: { error },
})

export const fetchALPASuccess = (alpa) => ({
	type: FETCH_AL_PA_SUCCESS,
	payload: { alpa },
})

export function fetchALPA(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchALPABegin())
		return fetch(`${URL}api/atelierlignes`, {
			method: "put",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchALPASuccess(json))
			})
			.catch(catchApiError(dispatch, fetchALPAError))
	}
}

export const FETCH_ATELIER_QUANTITES_BEGIN = "FETCH_ATELIER_QUANTITES_BEGIN"
export const FETCH_ATELIER_QUANTITES_ERROR = "FETCH_ATELIER_QUANTITES_ERROR"
export const FETCH_ATELIER_QUANTITES_SUCCESS = "FETCH_ATELIER_QUANTITES_SUCCESS"
export const FETCH_ATELIER_QUANTITES_RESET = "FETCH_ATELIER_QUANTITES_RESET"

export const fetchAtelierQuantitesBegin = () => ({
	type: FETCH_ATELIER_QUANTITES_BEGIN,
})

export const fetchAtelierQuantitesReset = () => ({
	type: FETCH_ATELIER_QUANTITES_RESET,
})

export const fetchAtelierQuantitesError = (error) => ({
	type: FETCH_ATELIER_QUANTITES_ERROR,
	payload: { error },
})

export const fetchAtelierQuantitesSuccess = (atelierQuantites) => ({
	type: FETCH_ATELIER_QUANTITES_SUCCESS,
	payload: { atelierQuantites },
})

export function fetchAtelierQuantites(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchAtelierQuantitesBegin())
		return fetch(`${URL}api/atelierlignes`, {
			method: "put",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchAtelierQuantitesSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchAtelierQuantitesError))
	}
}

export const setAtelier = (atelier) => {
	return (dispatch) => {
		dispatch({
			type: "SET_ATELIER",
			value: atelier,
		})
		return Promise.resolve()
	}
}

export const setAtelierTransaction = (transaction) => {
	return (dispatch) => {
		dispatch({
			type: "SET_ATELIER_TRANSACTION",
			value: transaction,
		})
		return Promise.resolve()
	}
}

export const setAtelierLigne = (atelierLigne) => {
	return (dispatch) => {
		dispatch({
			type: "ADD_ATELIERLIGNES",
			value: atelierLigne,
		})
		return Promise.resolve()
	}
}

//// TEST
export const testFetchAtelierReset = () => {
	return (dispatch) => {
		dispatch({
			type: FETCH_ATELIER_RESET,
		})
		return Promise.resolve()
	}
}
